module.exports = __webpack_public_path__ + "static/media/save_cash_icon.1a335f79.svg";